import { createComponent } from '@carvana/merch-components';
import {
  CommonSection,
  ContentContainer
} from '~/components/flp/Financing.styles';

export const HeroSection = createComponent(CommonSection, {
  className: 'relative bg-canvas-muted p-0'
});

export const Gradient = createComponent('div', {
  className: `absolute inset-0 z-0 h-3/4 bg-[image:var(--gradient-bg-image-mobile)] bg-cover bg-[top_left] bg-no-repeat sm:bg-[image:var(--gradient-bg-image)]`
});

export const Wrapper = createComponent('div', {
  className: 'relative z-1 px-2xl pb-0 pt-6xl sm:px-3xl sm:pb-0 sm:pt-8xl'
});

export const Container = createComponent(ContentContainer, {
  className:
    'm-auto flex flex-col items-center justify-center gap-6xl sm:gap-8xl'
});

export const Heading = createComponent('h1', {
  className:
    'self-stretch text-center uppercase text-text-inverse t-brand-sm sm:t-brand-md'
});
